import { Component, effect, inject } from '@angular/core';
import { Configuration } from '../../../../../models/configurators-2d/applications/fence/configuration';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';
import { FencePreviewFacadeService } from '../services/fence-preview.facade.service';
import { FencePreviewItem } from '../models/fence-preview-item';

@Component({
  selector: 'ng-fence-preview-fence',
  templateUrl: './fence-preview-fence.component.html',
  styleUrl: './fence-preview-fence.component.scss',
})
export class FencePreviewFenceComponent {
  private readonly fencePreviewFacadeService = inject(FencePreviewFacadeService);
  private readonly fenceService = inject(FenceService);

  /**
   * Permet de savoir si un item est chargé
   * Clé => item.position
   * Valeur => true si l'item est chargé, false sinon
   * @private
   */
  protected itemsLoaded = new Map<number, boolean>();

  protected get loading(): boolean {
    return this.itemsLoaded.size === 0 || Array.from(this.itemsLoaded.values()).some(isLoaded => !isLoaded);
  }

  constructor() {
    effect(() => {
      const items = this.fencePreviewFacadeService.items();

      if (!items || items.length === 0) {
        return;
      }

      this.itemsLoaded = new Map<number, boolean>();

      for (const item of items) {
        this.itemsLoaded.set(item.position, false);
      }
    });
  }

  protected get configuration(): Configuration {
    return this.fenceService.configuration;
  }

  protected get items(): FencePreviewItem[] {
    return this.fencePreviewFacadeService.items();
  }

  /**
   * Quand un item est chargé, on le renseigne dans le map
   * @param position
   * @protected
   */
  protected onLoaded(position: number): void {
    this.itemsLoaded.set(position, true);
  }
}
